import { css as h, LitElement as u, html as n, nothing as d } from "lit";
import { query as m, property as o, customElement as v } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b, f as g } from "./styles-scZ6dVz-.js";
import { b as y, a as k } from "./events-CkEPl0SM.js";
import { g as w } from "./a11y-DxQW21Jt.js";
var x = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, r = (t, i, s, l) => {
  for (var a = l > 1 ? void 0 : l ? $(i, s) : i, c = t.length - 1, p; c >= 0; c--)
    (p = t[c]) && (a = (l ? p(i, s, a) : p(a)) || a);
  return l && a && x(i, s, a), a;
};
let e = class extends u {
  constructor() {
    super(...arguments), this.inputId = w("ark-checkbox"), this.checked = !1, this.indeterminate = !1, this.size = "md", this.disabled = !1, this.required = !1, this.invalid = !1;
  }
  /** Focus the checkbox */
  focus(t) {
    this.inputElement?.focus(t);
  }
  /** Blur the checkbox */
  blur() {
    this.inputElement?.blur();
  }
  handleChange(t) {
    const i = t.target;
    this.checked = i.checked, this.indeterminate = !1, y(this, k.CHANGE, { checked: this.checked, value: this.value });
  }
  handleClick() {
    this.disabled || this.inputElement?.click();
  }
  updated(t) {
    t.has("indeterminate") && this.inputElement && (this.inputElement.indeterminate = this.indeterminate);
  }
  render() {
    const t = {
      wrapper: !0,
      [this.size]: !0,
      disabled: this.disabled,
      invalid: this.invalid
    }, i = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
        ${this.indeterminate ? n`<path d="M5 12h14"/>` : n`<path d="M20 6 9 17l-5-5"/>`}
      </svg>
    `;
    return n`
      <label
        part="wrapper"
        class=${f(t)}
        @click=${this.handleClick}
      >
        <input
          part="checkbox"
          type="checkbox"
          id=${this.inputId}
          name=${this.name ?? d}
          value=${this.value ?? d}
          .checked=${this.checked}
          ?disabled=${this.disabled}
          ?required=${this.required}
          aria-invalid=${this.invalid ? "true" : d}
          @change=${this.handleChange}
          @click=${(s) => s.stopPropagation()}
        />
        <span part="control" class="control">
          ${i}
        </span>
        <span part="label" class="label">
          <slot></slot>
        </span>
      </label>
    `;
  }
};
e.styles = [
  b,
  g,
  h`
      :host {
        display: inline-flex;
      }

      .wrapper {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-2);
        cursor: pointer;
      }

      .wrapper.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .control {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-default);
        background-color: var(--r5-bg);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
        flex-shrink: 0;
      }

      /* Sizes */
      .sm .control {
        width: 0.875rem;
        height: 0.875rem;
      }

      .md .control {
        width: 1rem;
        height: 1rem;
      }

      .lg .control {
        width: 1.25rem;
        height: 1.25rem;
      }

      /* Focus state */
      input:focus-visible + .control {
        border-color: var(--r5-border-focus);
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-primary-100);
      }

      /* Checked state */
      input:checked + .control {
        background-color: var(--r5-color-primary-600);
        border-color: var(--r5-color-primary-600);
      }

      /* Indeterminate state */
      input:indeterminate + .control {
        background-color: var(--r5-color-primary-600);
        border-color: var(--r5-color-primary-600);
      }

      /* Checkmark icon */
      .control svg {
        width: 75%;
        height: 75%;
        stroke: white;
        stroke-width: 3;
        opacity: 0;
        transform: scale(0.5);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      input:checked + .control svg,
      input:indeterminate + .control svg {
        opacity: 1;
        transform: scale(1);
      }

      /* Invalid state */
      .invalid .control {
        border-color: var(--r5-color-danger-500);
      }

      .invalid input:focus-visible + .control {
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-danger-100);
      }

      /* Label */
      .label {
        font-size: var(--r5-text-sm);
        color: var(--r5-text);
        user-select: none;
      }

      .sm .label {
        font-size: var(--r5-text-xs);
      }

      .lg .label {
        font-size: var(--r5-text-base);
      }
    `
];
r([
  m("input")
], e.prototype, "inputElement", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "checked", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "indeterminate", 2);
r([
  o({ type: String, reflect: !0 })
], e.prototype, "size", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "disabled", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "required", 2);
r([
  o({ type: Boolean, reflect: !0 })
], e.prototype, "invalid", 2);
r([
  o({ type: String })
], e.prototype, "name", 2);
r([
  o({ type: String })
], e.prototype, "value", 2);
e = r([
  v("ark-checkbox")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-checkbox-BCr28tBe.js.map
